import Head from 'next/head';
import Link from 'next/link';

import { ForexCardHelpSEO } from '@/utils/constants/MetaData';

const General = () => {
  return (
    <>
      <Head>
        <title>{ForexCardHelpSEO.metaTitle}</title>
        <meta name="description" content={ForexCardHelpSEO.metaDescription} />
        <meta
          property="og:description"
          content={ForexCardHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/forex/forex-cards/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Forex Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Forex Cards
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              Forex Cards
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  What is the validity of your Forex card?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Your Forex multi-currency card is valid for 5 years from the
                    date of issue. Post this, you will need to reissue a new
                    card against the same credentials.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  What should I do if my Forex card is stolen or lost?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    In case your Forex card is stolen or is lost, contact our
                    customer care team immediately at 1800 102 1616. Also,
                    opt-in for a replacement card to be delivered. This
                    replacement Forex card can be delivered PAN India with a
                    nominal fee
                    <br />
                    Please note that at Muthoot FinCorp ONE, we also issue a
                    backup Forex card along with your purchase so that you can
                    avoid the inconvenience and be hassle-free, in case your
                    primary card is stolen or lost. However, please make sure to
                    place a request to deactivate the primary Forex card and
                    activate the backup Forex card, when you start using the
                    replacement or secondary card.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  How can I block or deactivate my Forex card?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can block your Muthoot FinCorp ONE multi-currency Forex
                    card through our telephonic assistance. Just call our Forex
                    card partner Thomas Cook on 1800-2099-100 and place a
                    request to block or deactivate your card
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  Can I load multiple currencies in the Forex card?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The Muthoot FinCorp ONE Forex card is a multi-currency card.
                    You can load multiple currencies in your Forex card and it
                    will automatically select the accepted currency at ATMS, POS
                    etc.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  How can I reload my Forex card?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can reload your Muthoot FinCorp ONE Forex card on the go
                    and online. Go to the Muthoot FinCorp ONE website, click on
                    reload card and make your payment online. Once your order is
                    completed, we will recharge your card within 24* hours.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  Can I unload my Forex card?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, you can unload your Muthoot FinCorp ONE Forex card
                    online or by visiting the nearest Muthoot FinCorp Forex
                    branch to convert the remaining balance into INR instantly
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default General;
